import React from 'react'

import AuthLayout from '@/components/Layout/AuthLayout'
import LoginForm from '../components/LoginForm'

const Login = () => {
  return (
    <AuthLayout title="Vendor Management">
      <LoginForm />
    </AuthLayout>
  )
}

export default Login
